export default __webpack_public_path__ + "static/media/advertising.59323672.png";